import { render } from "./pigeonhole.vue?vue&type=template&id=356f7b87&scoped=true"
import script from "./pigeonhole.vue?vue&type=script&lang=js"
export * from "./pigeonhole.vue?vue&type=script&lang=js"

import "./pigeonhole.vue?vue&type=style&index=0&id=356f7b87&lang=scss&scoped=true"
import "./pigeonhole.vue?vue&type=style&index=1&id=356f7b87&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356f7b87"]])

export default __exports__